import './styles.css';
import clsx from 'clsx';

/*interface KitoToggleProps {
  id: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
  style?: "checkbox" | "slider" | "radio";
  prefix?: ReactNode;
  suffix?: ReactNode;
  fill?: boolean;
}
*/
export default function KitoToggle({ variant = 'checkbox', ...props } /*: Readonly<KitoToggleProps>*/) {
  return (
    <label key={props.id} className={clsx('kito-toggle', props.fill && 'kito-toggle__fill')}>
      {props.prefix && <span className="kito-toggle__prefix">{props.prefix}</span>}
      <input
        disabled={props.disabled}
        className={`kito-toggle__input kito-toggle__${variant}`}
        type="checkbox"
        id={props.id}
        checked={props.checked}
        onChange={(e) => props.onChange(e.target.checked)}
      />
      <span className="kito-toggle__checkmark" />
      {props.suffix && <span className="kito-toggle__suffix">{props.suffix}</span>}
    </label>
  );
}
